<ui-page-container size="medium">
  <mat-card>
    <mat-card-title>
      <p class="card-inner-title">
        {{ (entityId ? 'Modifica documento bibliografico' : 'Aggiungi documento bibliografico') | translate }}
      </p>
      <div
        class="alert-role"
        *roleVisibility="['create', 'update']; classNames: ['DocumentoBib']; behaviour: 'show'">
        <p>
          {{ 'Il tuo ruolo ti permette solamente di visualizzare le informazioni relative al documento bibliografico.' | translate }}
        </p>
        <p>
          {{ 'Nessuna azione di modifica avrà effetto.' | translate }}
        </p>
      </div>
    </mat-card-title>
    <mat-card-content class="source-container">
      <aside>
        <div class="source-general-actions">
          <app-card-actions
            *ngIf="entityId"
            className="DocumentoBib"
            [entity]="entityForm?.value"
            [entityId]="entityId"
            (changeStatus)="changeStatusHandler($event)">
          </app-card-actions>
        </div>
      </aside>
      <mat-tab-group animationDuration="0ms">
        <mat-tab [label]="'Generali' | translate">
          <form
            class="source-bib-general"
            *ngIf="entityForm"
            [formGroup]="entityForm"
            (ngSubmit)="dispatchAction(entityForm)">
            <mat-form-field class="input-expanse">
              <mat-label>{{'Codice Unico' | translate}}</mat-label>
              <input
                class="input-expanse"
                type="text"
                matInput
                formControlName="codiceUnico"
                [placeholder]="'Codice Unico' | translate">
            </mat-form-field>
            <mat-error
              class="message-error"
              *ngIf="entityControls?.codiceUnico?.touched && entityControls?.codiceUnico?.hasError('required')">
              {{ 'Codice unico obbligatorio' | translate }}
            </mat-error>

            <mat-form-field class="input-expanse">
              <mat-label>{{'Titolo' | translate}}</mat-label>

              <input
                class="input-expanse"
                type="text"
                matInput
                formControlName="titolo"
                [placeholder]="'Titolo' | translate">
            </mat-form-field>
            <mat-error
              class="message-error"
              *ngIf="entityControls?.titolo?.touched && entityControls?.titolo?.hasError('required')">
              {{ 'Titolo obbligatorio' | translate }}
            </mat-error>


            <mat-form-field class="input-expanse">
              <mat-label>{{'Titolo opera principale' | translate}}</mat-label>
              <input
                class="input-expanse"
                type="text"
                matInput
                formControlName="titoloOperaPrincipale"
                [placeholder]="'Titolo opera principale' | translate">
            </mat-form-field>

            <mat-form-field class="input-expanse">
              <mat-label>{{'Editore' | translate}}</mat-label>
              <input
                class="input-expanse"
                type="text"
                matInput
                formControlName="editore"
                [placeholder]="'Editore' | translate">
            </mat-form-field>
            <mat-form-field class="input-expanse">
              <mat-label>{{'Livello Bibliografico' | translate}}</mat-label>
              <input
                class="input-expanse"
                type="text"
                matInput
                formControlName="livelloBibliografico"
                [placeholder]="'Livello Bibliografico' | translate">
            </mat-form-field>
            <mat-form-field class="input-expanse">
              <mat-label>{{'Descrizione Fisica' | translate}}</mat-label>
              <input
                class="input-expanse"
                type="text"
                matInput
                formControlName="descrizioneFisica"
                [placeholder]="'Descrizione Fisica' | translate">
            </mat-form-field>
            <mat-form-field class="input-expanse">
              <mat-label>{{'Curatore' | translate}}</mat-label>
              <input
                class="input-expanse"
                type="text"
                matInput
                formControlName="curatore"
                [placeholder]="'Curatore' | translate">
            </mat-form-field>
            <mat-form-field class="input-expanse">
              <mat-label>{{'Fondo' | translate}}</mat-label>
              <input
                class="input-expanse"
                type="text"
                matInput
                formControlName="fondo"
                [placeholder]="'Fondo' | translate">
            </mat-form-field>
            <mat-form-field class="input-expanse">
              <mat-label>{{'Collocazione' | translate}}</mat-label>
              <input
                class="input-expanse"
                type="text"
                matInput
                formControlName="collocazione"
                [placeholder]="'Collocazione' | translate">
            </mat-form-field>
            <mat-form-field class="input-expanse">
              <mat-label>{{'Luogo edizione' | translate}}</mat-label>
              <input
                class="input-expanse"
                type="text"
                name="name"
                matInput
                formControlName="luogoEdizione"
                [placeholder]="'Luogo edizione' | translate">
            </mat-form-field>

            <mat-form-field class="input-expanse">
              <mat-label>{{'Anno Edizione' | translate}}</mat-label>
              <input
                class="input-expanse"
                type="text"
                matInput
                formControlName="annoEdizione"
                [placeholder]="'Anno Edizione' | translate">
            </mat-form-field>

            <mat-form-field class="input-expanse">
              <mat-label>{{'Nazione' | translate}}</mat-label>
              <input
                class="input-expanse"
                type="text"
                matInput
                formControlName="nazione"
                [placeholder]="'Nazione' | translate">
            </mat-form-field>

            <mat-form-field class="input-expanse">
              <mat-label>{{'Note' | translate}}</mat-label>
              <textarea
                class="input-expanse"
                type="text"
                matInput
                formControlName="note"
                [placeholder]="'Note' | translate"></textarea>
            </mat-form-field>

            <mat-form-field class="input-expanse">
              <mat-label>{{'Tipo' | translate}}</mat-label>
              <input
                class="input-expanse"
                type="text"
                matInput
                formControlName="tipo"
                [placeholder]="'Tipo' | translate">
            </mat-form-field>

            <h3>{{ 'Autore' | translate }}</h3>
            <ng-container *roleVisibility="['create', 'update']; classNames: ['DocumentoBib']">
              <p>
                {{ 'Inserisci uno o più autori.' | translate }}
              </p>
              <ui-input-repeatable [form]="entityForm?.get('autore')">
                <ng-template
                  let-item="item"
                  let-index="index">
                  <mat-form-field>
                    <input
                      matInput
                      placeholder="Autore"
                      [formControl]="item">
                  </mat-form-field>
                </ng-template>
              </ui-input-repeatable>
            </ng-container>
            <ng-container *roleVisibility="['create', 'update']; classNames: ['DocumentoBib']; behaviour: 'show'">
              <p *ngIf="(entityForm?.get('autore')?.controls || []).length > 0">{{ 'Autori presenti' | translate }}</p>
              <p *ngIf="(entityForm?.get('autore')?.controls || []).length === 0">{{ 'Nessun autore presente' | translate }}</p>
              <ul>
                <li *ngFor="let t of entityForm?.get('autore')?.controls || []">{{ t.value }}</li>
              </ul>
            </ng-container>

            <h3>{{ 'Lingua' | translate }}</h3>
            <ng-container *roleVisibility="['create', 'update']; classNames: ['DocumentoBib']">
              <p>
                {{ 'Inserisci una o più lingue.' | translate }}
              </p>
              <ui-input-repeatable [form]="entityForm?.get('lingua')">
                <ng-template
                  let-item="item"
                  let-index="index">
                  <mat-form-field>
                    <input
                      matInput
                      placeholder="Lingua"
                      [formControl]="item">
                  </mat-form-field>
                </ng-template>
              </ui-input-repeatable>
            </ng-container>
            <ng-container *roleVisibility="['create', 'update']; classNames: ['DocumentoBib']; behaviour: 'show'">
              <p *ngIf="(entityForm?.get('lingua')?.controls || []).length > 0">{{ 'Lingue presenti' | translate }}</p>
              <p *ngIf="(entityForm?.get('lingua')?.controls || []).length === 0">{{ 'Nessuna lingua presente' | translate }}</p>
              <ul>
                <li *ngFor="let t of entityForm?.get('lingua')?.controls || []">{{ t.value }}</li>
              </ul>
            </ng-container>

            <h3>{{ 'Tag' | translate }}</h3>
            <ng-container *roleVisibility="['create', 'update']; classNames: ['DocumentoBib']">
              <p>
                {{ 'Inserisci uno o più tag.' | translate }}
              </p>
              <mat-form-field
                class="input-expanse"
                appearance="fill">
                <mat-label>{{ 'Tag' | translate }}</mat-label>
                <mat-chip-grid #chipList>
                  <mat-chip-row
                    *ngFor="let tag of entityForm?.get('tag').value; let i = index"
                    [removable]="true"
                    (removed)="removeTagHandler(entityForm?.get('tag'), i)">
                    {{ tag }}
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip-row>
                  <input
                    #inputTag
                    placeholder="Nuovo tag"
                    [matChipInputAddOnBlur]="true"
                    [matChipInputFor]="chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="addTagHandler(entityForm?.get('tag'), $event, inputTag)">
                </mat-chip-grid>
              </mat-form-field>
            </ng-container>

            <ng-container *roleVisibility="['create', 'update']; classNames: ['DocumentoBib']; behaviour: 'show'">
              <p *ngIf="(entityForm?.get('tag')?.controls || []).length > 0">{{ 'Tag presenti' | translate }}</p>
              <p *ngIf="(entityForm?.get('tag')?.controls || []).length === 0">{{ 'Nessun tag presente' | translate }}</p>
              <mat-chip-listbox>
                <mat-chip *ngFor="let t of entityForm?.get('tag')?.controls || []">{{ t.value }}</mat-chip>
              </mat-chip-listbox>
            </ng-container>

            <h3>{{ 'Immagine' | translate }}</h3>
            <app-media-form-view
              [mediaId]="entityForm.get('immagine')?.value"
              [excludedExtensions]="['pdf']"
              (update)="updateImageHandler($event)">
            </app-media-form-view>
            <h3>{{ 'File' | translate }}</h3>
            <app-media-form-view
              [mediaId]="entityForm.get('file')?.value"
              (update)="updateFileHandler($event)">
            </app-media-form-view>

            <div class="source-actions">
              <button
                *roleVisibility="['create', 'update']; classNames: ['DocumentoBib']"
                mat-raised-button
                color="primary"
                type="submit">
                {{ (entityId ? 'Salva' : 'Aggiungi') | translate }}
              </button>
            </div>
          </form>
        </mat-tab>
        <mat-tab
          [label]="'Beni correlati' | translate"
          *ngIf="mode === 'edit'">
          <app-bib-cards [sourceBib]="entityForm?.value"></app-bib-cards>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
</ui-page-container>
